import React from 'react';
import { Button, Box, CircularProgress, useTheme, useMediaQuery } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ProblemStatus } from '../../../models/Problem';

interface ProblemActionsProps {
  status: ProblemStatus;
  isProcessing: boolean;
  onStatusChange: () => void;
  onDelete: () => void;
  onSolve: () => void;
}

const ProblemActions: React.FC<ProblemActionsProps> = ({
  status,
  isProcessing,
  onStatusChange,
  onDelete,
  onSolve,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box display="flex" flexDirection={isMobile ? 'column' : 'row'} gap={1} mb={2}>
      <Button
        onClick={onStatusChange}
        variant="outlined"
        color="primary"
        startIcon={<EditIcon />}
        fullWidth={isMobile}
        disabled={status === 'in_progress' || status === 'completed'}
      >
        Toggle Open/Closed
      </Button>
      <Button
        onClick={onDelete}
        variant="outlined"
        color="secondary"
        startIcon={<DeleteIcon />}
        fullWidth={isMobile}
      >
        Delete
      </Button>
      <Button
        onClick={onSolve}
        variant="contained"
        color="success"
        startIcon={
          isProcessing ? <CircularProgress size={20} color="inherit" /> : <PlayArrowIcon />
        }
        disabled={isProcessing || status === 'completed'}
        fullWidth={isMobile}
      >
        {isProcessing ? 'Processing...' : 'Solve'}
      </Button>
    </Box>
  );
};

export default ProblemActions;
